import React, { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide eye toggle. The toggle button is
 * absolutely positioned and uses theme-aware text colors so it remains
 * visible in both light and dark modes.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", inputClassName = "", testId, ...rest }, ref
) {
  const [shown, setShown] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        ref={ref}
        type={shown ? "text" : "password"}
        data-testid={testId}
        className={`w-full px-3 py-2.5 pr-11 bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-ring ${inputClassName}`}
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShown((v) => !v)}
        data-testid={testId ? `${testId}-toggle` : "pw-toggle"}
        aria-label={shown ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary transition"
      >
        {shown ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
